var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17188 5.17184C3.92199 4.42195 4.93922 4.00069 5.99988 4.00069C7.06054 4.00069 8.07777 4.42195 8.82788 5.17184L9.99988 6.34284L11.1719 5.17184C11.5409 4.7898 11.9822 4.48507 12.4703 4.27543C12.9583 4.06579 13.4832 3.95545 14.0143 3.95083C14.5454 3.94622 15.0721 4.04743 15.5637 4.24855C16.0553 4.44967 16.5019 4.74669 16.8775 5.12226C17.253 5.49783 17.55 5.94443 17.7512 6.43602C17.9523 6.92761 18.0535 7.45432 18.0489 7.98544C18.0443 8.51656 17.9339 9.04144 17.7243 9.52945C17.5146 10.0175 17.2099 10.4588 16.8279 10.8278L9.99988 17.6568L3.17188 10.8278C2.42199 10.0777 2.00073 9.06049 2.00073 7.99984C2.00073 6.93918 2.42199 5.92195 3.17188 5.17184Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/donation.4e7de60f241bdb8e8fa608e81b905499.svg";
export { ForwardRef as ReactComponent };